













import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get href() {
    return window.location.href;
  }
  private goRoute(item: any) {
    this.$router.push(item.path);
  }
}
